export default __webpack_public_path__ + "static/protection-logo2-1348e501a1be61288c75478a93cbf9c6.png";